import { useQuery } from '@tanstack/react-query';

import { PayStationEvent } from 'src/features/payment/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/paystations/pay-station-event/:eventId/`;

type QueryFnType = typeof queryFn;

type DTO = {
    parkingId: string;
    eventId: string;
};

const queryFn = ({ eventId, parkingId }: DTO): Promise<PayStationEvent> => {
    return axios.get(formatResourcePath(RESOURCE, { eventId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_PAY_STATION_EVENT_RESOURCE, useQueryHook as useGetPayStationEvent };
